import { CATEGORIES } from '../../constants/globals'

export default {
  [CATEGORIES[0]]: [{ introIntlId: 'agricultural.introduction.part1' }],
  [CATEGORIES[1]]: [
    { introIntlId: 'lumbering.introduction.part1' },
    { introIntlId: 'lumbering.introduction.part2' },
    { introIntlId: 'lumbering.introduction.part3' }
  ],
  [CATEGORIES[2]]: [{ introIntlId: 'civilengineering.introduction.part1' }]
}
